import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="text-lg font-heading text-background-50 mb-4">
                <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">韩漫漫画网</Link>
              </h4>
              <p className="text-sm text-background-400 leading-relaxed">
                致力于为漫画爱好者提供最优质的韩漫免费阅读服务。海量漫画资源，高清画质，流畅阅读体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
                <li><Link to="/category/rexue" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">漫画分类</Link></li>
                <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
              <ul className="space-y-2">
                {categories.slice(0, 5).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}漫画
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
              <ul className="space-y-2 text-sm text-background-400">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span>contact@hanmancomic.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-customer-service-2-line text-primary-400"></i>
                  <span>在线客服：每日 9:00-21:00</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 韩漫漫画网 - 韩漫画免费网站。本站所有漫画均来自互联网，版权归原作者所有。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">用户协议</a>
              <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}